module.exports = {
  "wxc-tab-page": {
    "width": 750,
    "flexDirection": "column",
    "backgroundColor": "#f2f3f4"
  },
  "tab-title-list": {
    "flexDirection": "row"
  },
  "title-item": {
    "justifyContent": "center",
    "alignItems": "center",
    "flexDirection": "column",
    "borderBottomStyle": "solid",
    "position": "relative"
  },
  "border-bottom": {
    "position": "absolute",
    "bottom": 0
  },
  "tab-page-wrap": {
    "width": 750,
    "overflow": "hidden",
    "position": "relative"
  },
  "tab-container": {
    "flex": 1,
    "flexDirection": "row",
    "position": "absolute"
  },
  "tab-text": {
    "lines": 1,
    "textOverflow": "ellipsis"
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-7d22c6d9!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-tab-page/index.vue
// module id = 200
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28